import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';

import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import { LayoutContainer } from 'components/layout/styled';

interface MenuDebugModalProps {
  onClose: () => void;
  onOpenEventMessage: string;
}

export const DebugToolModal: React.FC<React.PropsWithChildren<MenuDebugModalProps>> = ({
  children,
  onClose,
  onOpenEventMessage,
}) => {
  return (
    <ActionsheetWrapper onOpenEventMessage={onOpenEventMessage} isOpen onClose={onClose}>
      <ActionsheetContent paddingBottom="$2.5">
        <LayoutContainer isModal width="full">
          <ScrollView>{children}</ScrollView>
        </LayoutContainer>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
